import React, { Fragment } from 'react';
import Footer from '../../component/Other/Footer';
import Navbar from '../../component/Other/Navbar';
import Head from '../../component/Page/Head';

const Privacy = () => {
  return (
    <Fragment>
      <div className="overflow-hidden">
        <div className="bg__blue-2">
          <Navbar />
          <Head title="Aviso de privacidad" />
        </div>
        <img src="./../images/Subtract.png" className="w-100 img-cover" alt="" />

        <section>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="wrapper__text-wrap">
                  <h1 className="semi-bold font__size--32 text__32-1024 text__32-md text__32-sm mb-3">📄 Aviso de Privacidad – ListoPago</h1>
                  <p className="normal font__size--16 text__16-1024 color__gray-1 lh-2 mb-2">
                    <strong>Última actualización:</strong> 1 de febrero de 2026
                  </p>
                  <p className="normal font__size--16 text__16-1024 color__gray-1 lh-2 mb-2">
                    <strong>Responsable:</strong> Brandon Stiven Zárate Vargas
                  </p>
                  <p className="normal font__size--16 text__16-1024 color__gray-1 lh-2 mb-5">
                    <strong>Correo de contacto:</strong>{' '}
                    <a href="mailto:soporte@listopago.com.co" className="color__purple">soporte@listopago.com.co</a>
                  </p>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">1. ¿Qué datos personales recopilamos?</h2>
                    <ul className="list-unstyled normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      <li className="mb-2"><strong>Datos de registro:</strong> Nombre, correo electrónico y número de celular (si usas inicio con Google o correo).</li>
                      <li className="mb-2"><strong>Datos de uso:</strong> Fotos de comprobantes bancarios que subes a la app (transferencias de Nequi, Bancolombia, etc.).</li>
                      <li className="mb-2"><strong>Metadatos:</strong> Fecha, hora y tipo de dispositivo desde el que usas ListoPago.</li>
                    </ul>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">2. ¿Para qué usamos tus datos?</h2>
                    <ul className="list-unstyled normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      <li className="mb-2">Procesar y organizar tus transacciones financieras.</li>
                      <li className="mb-2">Mejorar la precisión del reconocimiento automático (OCR) de comprobantes.</li>
                      <li className="mb-2">Enviarte notificaciones sobre tu cuenta (ej. "Tus 15 días gratis de prueba terminan hoy").</li>
                      <li className="mb-2">Cumplir con obligaciones legales en Colombia.</li>
                    </ul>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">3. Almacenamiento de imágenes</h2>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2 mb-0">
                      Las imágenes de comprobantes bancarios se almacenan temporalmente en los planes Premium durante 72 horas para permitir re-procesamiento o generación de reportes. En los planes Básico y Plus, las imágenes no se conservan después del procesamiento.
                    </p>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">4. ¿Compartimos tus datos?</h2>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2 mb-3">
                      No vendemos ni alquilamos tus datos a terceros.
                    </p>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2 mb-2">Solo compartimos lo estrictamente necesario con:</p>
                    <ul className="list-unstyled normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      <li className="mb-2"><strong>Google Cloud Vision API:</strong> Para procesar imágenes (solo durante el análisis, no almacenamos las fotos originales).</li>
                      <li className="mb-2"><strong>Proveedores de hosting:</strong> Donde se almacenan tus datos (servidores en EE.UU., bajo estándares de seguridad).</li>
                    </ul>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">5. Tus derechos</h2>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2 mb-2">Puedes:</p>
                    <ul className="list-unstyled normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      <li className="mb-2">Acceder, corregir o eliminar tus datos.</li>
                      <li className="mb-2">Solicitar la portabilidad de tu información.</li>
                      <li className="mb-2">Revocar el consentimiento en cualquier momento (eliminando tu cuenta en la app).</li>
                    </ul>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">6. Seguridad</h2>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      Usamos cifrado SSL/TLS y prácticas de seguridad estándar para proteger tus datos. Sin embargo, no almacenamos contraseñas, números de cuenta ni llaves financieras.
                    </p>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">7. Cambios en esta política</h2>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      Actualizaremos este aviso si cambian nuestras prácticas. La versión vigente siempre estará en esta página.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </Fragment>
  );
};

export default Privacy;
